import {CalBuilder} from "./CalBuilder";

export let xCalendar = new CalBuilder();
xCalendar._applyConfig();
